const rankingData = [
  {
    name: 'Rankings',
    link: '/rankings-generales/ranking-universidades-2021/',
    rankings: [
      {
        name: 'Top 10 Universidades Chilenas',
        link: '/rankings-generales/ranking-universidades-2021/',
        slug: 'ranking-universidades-2021',
        content: `<p>En esta, la 22ª versión del Ranking de Universidades, nuestro objetivo sigue siendo el mismo: entregar información que sirva a los jóvenes y a sus familias para tomar una decisión informada. Es una radiografía del año, de cómo la percepción de calidad que el mercado laboral asocia a cada plantel, la calidad de la gestión institucional, de los académicos y de los alumnos, así como los niveles de investigación alcanzados por las casas de estudio, han avanzado en los últimos 12 meses. Son estas cinco dimensiones con los cuales se construye el ranking.</p>

        <p>Este año, por primera vez desde 2013, ingresa una nueva universidad al Top 10. La U. de La Frontera desplaza al 11° lugar a la U. de Talca. Además, la actual medición arrojó una par de cambios: la U. Técnica Federico Santa María escaló un puesto del 5° al 4° y la U. Adolfo Ibáñez bajó al 4° lugar. Mientras que la U. de los Andes subió del 10° al 9°. </p>
        
        <p>¿Qué tienen en común estos planteles? Reputación entre los empleadores, más de seis años de acreditación, excelencia en la investigación y un cuerpo docente donde destaca la presencia de académicos con grado de doctor. No es gratuito que encabecen la tabla tres casas de estudio que cuentan con siete años de acreditación, el tiempo máximo que entrega la CNA.</p>`,
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            data: {
              fundacion: '1888',
              rector: 'Ignacio Sánchez',
              sedes: 'Santiago / Villarrica',
              acreditados: '7',
              puntaje: '656,3',
            },
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            data: {
              fundacion: '1842',
              rector: 'Ennio Vivaldi',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '647,4',
            },
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            data: {
              fundacion: '1919',
              rector: 'Carlos Saavedra',
              sedes: 'Concepción / Chillán / Los Ángeles',
              acreditados: '7',
              puntaje: '594,4',
            },
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            data: {
              fundacion: '1926',
              rector: 'Darcy Fuenzalida',
              sedes: 'Valparaíso / Viña del Mar / Santiago / Concepción',
              acreditados: '6',
              puntaje: '599,9',
            },
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            data: {
              fundacion: '1988',
              rector: 'Harald Beyer',
              sedes: 'Santiago / Viña del Mar',
              acreditados: '6',
              puntaje: '625,5',
            },
          },
          {
            name: 'Pontificia Universidad de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            data: {
              fundacion: '1924',
              rector: 'Claudio Elortegui',
              sedes: 'Valparaíso / Viña del Mar / Quilpué / Quillota',
              acreditados: '6',
              puntaje: '575,9',
            },
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            data: {
              fundacion: '1954',
              rector: 'Hans Richter',
              sedes: 'Valdivia / Puerto Montt / Coyhaique',
              acreditados: '6',
              puntaje: '561,3',
            },
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            data: {
              fundacion: '1849',
              rector: 'Juan Manuel Zolezzi',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '579,4',
            },
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            data: {
              fundacion: '1989',
              rector: 'José Antonio Guzmán',
              sedes: 'Santiago',
              acreditados: '5',
              puntaje: '629,4',
            },
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            data: {
              fundacion: '1989',
              rector: 'Eduardo Hebel Weiss',
              sedes: 'Temuco / Pucón / Angol',
              acreditados: '6',
              puntaje: '569,3',
            },
          },
        ],
      },
      {
        name: 'Tabla de Posiciones',
        link: '/rankings-generales/tabla-de-posiciones/',
        slug: 'tabla-de-posiciones',
        content:
          '<p>Existe consenso en que se requiere mejorar la calidad de la educación en todos los niveles, de ahí la importancia de conocer los avances que presentan las instituciones de educación superior, sobre todo en momentos en que 275 mil jóvenes conocerán los puntajes obtenidos en la PDT, dando inicio el 11 de enero de 2022 al proceso de admisión. Son tres días en que se pondrá a prueba la certeza de qué se quiere estudiar, la motivación y las capacidades que se tienen para escoger una carrera. Para tomar una decisión informada, hemos preparado este especial. En esta oportunidad, en el Ranking de Universidades, que se construye con información del año, solo 11 planteles mantuvieron su posición, mientras que otros 14 descendieron. Entre las mayores alzas se encuentra la U. Católica del Maule, que aumentó cinco puestos —gracias al incremento de sus académicos con doctorado y el impacto de sus investigaciones—, le sigue U. de La Serena, plantel que saltó del 26 al 21. La casa de estudios nortina registra la mayor alza de todos los rankings: en investigación sube 14 lugares, ello se debe a que el 60% de sus investigaciones se publican en el 25% de las revistas que tienen mayor impacto en la comunidad científica. Y sí de impacto se trata, son las publicaciones de la U. Técnico Santa María y de la U. Diego Portales las que presentan el mayor índice de impacto normalizado, el 1,7 que alcanzan sus trabajos significa que son citados un 70% más que la media mundial. </p>',
      },
      {
        name: 'Percepción de calidad del mercado laboral',
        link: '/rankings-generales/percepcion-de-calidad/',
        slug: 'percepcion-de-calidad',
      },
      {
        name: 'Percepción de calidad de la gestión',
        link: '/rankings-generales/percepcion-de-calidad-de-la-gestion/',
        slug: 'percepcion-de-calidad-de-la-gestion',
      },
      {
        name: 'Percepción de calidad de los académicos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-academicos/',
        slug: 'percepcion-de-calidad-de-los-academicos',
      },
      {
        name: 'Percepción de calidad de los alumnos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-alumnos/',
        slug: 'percepcion-de-calidad-de-los-alumnos',
      },
      {
        name: 'Percepción de calidad de la investigación',
        link: '/rankings-generales/percepcion-de-calidad-de-la-investigacion/',
        slug: 'percepcion-de-calidad-de-la-investigacion',
      },
    ],
  },
  {
    name: 'Top 10 por Carrera',
    link: '/rankings-por-carrera/arquitectura/',
    adid: 'div-gpt-ad-rankingu-0',
    rankings: [
      {
        name: 'Arquitectura',
        link: '/rankings-por-carrera/arquitectura/',
        slug: 'arquitectura',
        adid: 'div-gpt-ad-rankingu-0',
        content:
          '<p>Al igual que en 2020, las universidades PUC, la Chile, la Católica de Valparaíso, la Federico Santa María y la de Concepción mantienen intactas sus posiciones. Eso sí, aterriza en el décimo lugar la U. del Desarrollo, puesto que no ostentaba desde 2013, último año que estuvo en el Top 10. En 2021, fueron 3.033 alumnos los que ingresaron a primer año de Arquitectura, convirtiéndose así en la novena carrera que más estudiantes atrajo. Según mifuturo.cl, un arquitecto recién titulado puede ganar en promedio $840 mil, subiendo a $1,4 millones al 5° año de trabajo, mientras que la empleabilidad llega al 78% al segundo año laboral. De los planteles con mejores índices, destacan la PUC y la Chile: más del 80% de sus titulados se empleará al primer año. En cuanto al perfil de los futuros arquitectos, ocho de cada 10 provienen de establecimientos particulares y subvencionados.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: ' 95,35%',
            ranking2020: '2',
          },
          {
            name: 'Pontificia Universidad de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '81,51%',
            ranking2020: '3',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '81,23%',
            ranking2020: '4',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '78,76%',
            ranking2020: '5',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '73,25%',
            ranking2020: '7',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
            percepcion: '73,01%',
            ranking2020: '9',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '72,47%',
            ranking2020: '6',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '71,93%',
            ranking2020: '10',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '69,67%',
            ranking2020: '17',
          },
        ],
      },
      {
        name: 'Derecho',
        link: '/rankings-por-carrera/derecho/',
        slug: 'derecho',
        adid: 'div-gpt-ad-rankingu-3',
        content:
          '<p>Este año entra la U. de Santiago al cuadro de honor en la décima posición, desplazando del Top 10 a la U. Austral. La PUC y la Chile siguen ocupando los dos primeros lugares y la de Concepción escala un puesto, quedando tercera. Derecho se mantiene como una de las disciplinas favoritas, con 9.235 matriculados en primer año y más de 42 mil en total. Y aunque es una carrera larga y exigente, la gran demanda por estudiarla se explica, en parte, por los sueldos. Un recién titulado promedia sobre $1,4 millones mensuales, subiendo a $1.900.000 al quinto año. A esto, se suma que el 73% de sus alumnos estará trabajando al primer año, subiendo al 80% para el segundo año. Las universidades más prestigiosas coinciden con las más demandadas en el campo laboral: el 92% de los estudiantes de la PUC y de la Chile estará empleado al primer año.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: ' 98,02%',
            ranking2020: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '90,74%',
            ranking2020: '4',
          },
          {
            name: 'Pontificia Universidad de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '89,23%',
            ranking2020: '3',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '83,05%',
            ranking2020: '5',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '82,75%',
            ranking2020: '6',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '81,04%',
            ranking2020: '8',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '77,86%',
            ranking2020: '7',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '77,19%',
            ranking2020: '9',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '71,88%',
            ranking2020: '11',
          },
        ],
      },
      {
        name: 'Ingeniería Civil Industrial',
        link: '/rankings-por-carrera/civil/',
        slug: 'civil',
        adid: 'div-gpt-ad-rankingu-1',
        content:
          '<p>La sorpresa este año en el ranking es la reaparición de la U. Diego Portales, que ingresó a la décima posición, la misma que tenía en 2019. Los siete primeros lugares se mantienen igual que en 2020. Su matrícula promedia 5.272 nuevas plazas este año con un total de 27.800 alumnos que estudian Ingeniería Civil en alguno de los más de 90 programas que se imparten a lo largo del país. Cifras altas que se explican por lo requerido que son sus egresados: el 92% estará trabajando al segundo año de titulado. Otra razón para estudiarla es que la inversión inicial se recupera a los pocos años. Un ingeniero civil recién titulado puede ganar $1,5 millones, mientras que al quinto año recibirá $2.300.000 mensual. El sueldo mejora aún más entre quienes se ubican en el 10% superior: $3,8 millones, pero sus pares inferiores reciben $828 mil.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '98,71%',
            ranking2020: '2',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '93,75%',
            ranking2020: '3',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '88,20%',
            ranking2020: '4',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '82,94%',
            ranking2020: '5',
          },
          {
            name: 'Pontificia Universidad de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '80,50%',
            ranking2020: '6',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '77,91%',
            ranking2020: '7',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '71,59%',
            ranking2020: '9',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '70,96%',
            ranking2020: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '69,03%',
            ranking2020: '11',
          },
        ],
      },
      {
        name: 'Ingeniería Comercial',
        link: '/rankings-por-carrera/comercial/',
        slug: 'comercial',
        adid: 'div-gpt-ad-rankingu-2',
        content:
          '<p>Son las mismas 10 universidades las que ocupan el cuadro de honor desde el 2015, pero en este verdadero club, por primera vez, los planteles mantienen sus posiciones con respecto a la versión 2020. El interés por estudiar esta carrera sigue al alza, es la tercera licenciatura que más estudiantes congregó este año, 8.650. La razón de ser una de las más cotizadas entre los jóvenes se debe, principalmente, a la proyección laboral de sus egresados: el 80% de los titulados tendrán un trabajo estable al primer año, subiendo a un 88% en el segundo. Además, los sueldos pueden ir desde $1.172.000 el primer año hasta $1,8 millones a los cinco años de titulados, aunque el tramo superior alcanzará ingresos que superarán los $3 millones. El amplio campo laboral hace de esta disciplina una de las más requeridas por los alumnos: 36% de ellos proviene de colegios particulares pagados.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '95,91%',
            ranking2020: '2',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '92,24%',
            ranking2020: '3',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '86,65%',
            ranking2020: '4',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '83,36%',
            ranking2020: '5',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '80,40%',
            ranking2020: '6',
          },
          {
            name: 'Pontificia Universidad de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '77,55%',
            ranking2020: '7',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '75,93%',
            ranking2020: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '73,96%',
            ranking2020: '9',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '73,33%',
            ranking2020: '10',
          },
        ],
      },
      {
        name: 'Medicina',
        link: '/rankings-por-carrera/medicina/',
        slug: 'medicina',
        adid: 'div-gpt-ad-rankingu-5',
        content:
          '<p>Aunque con cambios de posiciones, son los mismos 10 planteles que están presentes en el cuadro de honor, con respecto a la versión 2020. Eso sí, cinco casas de estudio mantienen inalterable sus lugares: las universidades Católica, de Chile, de Concepción, de los Andes y Austral. A pesar de su extensa malla curricular, un aspecto sigue manteniéndola como favorita de los alumnos: altos sueldos y gran empleabilidad. Los más de 17 mil matriculados en la carrera a lo largo del país saben que, una vez egresados, pueden llegar a ganar $2,1 millones, subiendo a $3,5 millones tras cinco años de ejercicio en el mercado laboral. Un mercado que también premia a los futuros médicos con un 91% de ellos trabajando tras titularse. Eso sí, es una de las carreras que tiene los más altos aranceles del sistema: entre $5 millones y $9,4 millones.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '97,19%',
            ranking2020: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '93,02%',
            ranking2020: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '90,21%',
            ranking2020: '4',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '86,21%',
            ranking2020: '5',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '83,33%',
            ranking2020: '9',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '83%',
            ranking2020: '6',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '81,51%',
            ranking2020: '7',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '81,40%',
            ranking2020: '8',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '72,29%',
            ranking2020: '10',
          },
        ],
      },
      {
        name: 'Odontología',
        link: '/rankings-por-carrera/odontologia/',
        slug: 'odontologia',
        adid: 'div-gpt-ad-rankingu-6',
        content:
          '<p>Al igual que el año pasado, se mantienen en los primeros lugares: de Chile, de Concepción y la Católica. Se mantiene también la matrícula, con 14 mil futuros odontólogos. El 67% de ellos estará trabajando al egresar, subiendo a un 85%, en el segundo año de ejercicio. Lo que se traduce en sueldos que comienzan cercanos al millón de pesos y que, tras cinco años, pueden subir a $1,7 millones, aunque los mejores pagados superaran los $2,5 millones. Por otra parte, quienes ingresen deben tener claro que en promedio tardarán 5 semestres más en titularse que lo establecido en la malla formal; pese a ello tiene una alta tasa de retención: sólo uno de cada diez estudiantes deserta tras finalizar el primer año de estudio. Y, al igual que otras carreras del área de la Salud, sus aranceles son altos, fluctuando entre los $3,7 millones y $9 millones.</p>',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '99,93%',
            ranking2020: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '96,52%',
            ranking2020: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '93,30%',
            ranking2020: '6',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '92,81%',
            ranking2020: '4',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '87,89%',
            ranking2020: '8',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '85,32%',
            ranking2020: '5',
          },
          {
            name: 'Universidad Arturo Prat',
            abbr: 'U. Arturo Prat',
            logo: 'UAPrat',
            percepcion: '83,34%',
            ranking2020: '9',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '81,02%',
            ranking2020: '10',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '79,88%',
            ranking2020: '7',
          },
        ],
      },
      {
        name: 'Periodismo',
        link: '/rankings-por-carrera/periodismo/',
        slug: 'periodismo',
        adid: 'div-gpt-ad-rankingu-7',
        content:
          '<p>Al igual que en las dos versiones anteriores, en este ranking se mantienen las mismas 10 universidades, siempre lideradas por las universidades Católica y la Chile. Las remuneraciones y la empleabilidad se mantienen estables en los últimos años. Y aunque no son los sueldos más atractivos de este ranking, un periodista tras titularse ganará cerca de $757 mil mensual, bordeando el millón cien mil pesos al quinto año de trabajo; mientras que el 78% estará empleado. La irrupción del área digital ha logrado que los planteles aseguren mejores proyecciones para sus titulados. Hoy, sus egresados pueden desempeñarse en áreas distintas a los tradicionales departamentos de prensa de los medios de comunicación. El trabajo con el que muchos periodistas están recuperando lo invertido es el de "community manager" de empresas.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '94,38%',
            ranking2020: '2',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '90,56%',
            ranking2020: '4',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '84,52%',
            ranking2020: '5',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '83,83%',
            ranking2020: '6',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '80,54%',
            ranking2020: '3',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '77,83%',
            ranking2020: '8',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '77,38%',
            ranking2020: '9',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '76,92%',
            ranking2020: '7',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '75,29%',
            ranking2020: '10',
          },
        ],
      },
      {
        name: 'Psicología',
        link: '/rankings-por-carrera/psicologia/',
        slug: 'psicologia',
        adid: 'div-gpt-ad-rankingu-8',
        content:
          '<p>Al igual que en los últimos seis años, la tabla la lidera la U. Católica seguida por la Chile. Psicología fue en 2021 la carrera favorita de los estudiantes que ingresaron a primer año: 9.350. Esta cifra la convierte en la licenciatura que más matrícula convocó. Así, son 38 mil los futuros psicólogos que están en las aulas. Y aunque no es una de las carreras mejores pagadas, puesto que recién al quinto año de ejercicio un psicólogo promedia $1 millón al mes, sí es una disciplina que mantiene su empleabilidad. Un 79% de sus alumnos estará trabajando al segundo año de titulación. Pese a que formalmente los alumnos debieran cursarla en 10 semestres, pueden tardarse otros dos semestres. En cuanto al perfil de los futuros psicólogos, un 55% proviene de colegios subvencionados, mientras que seis de cada diez estudiantes son mujeres.</p>',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '99,19%',
            ranking2020: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '92,96%',
            ranking2020: '4',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '88,28%',
            ranking2020: '3',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '87,38%',
            ranking2020: '5',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '84,88%',
            ranking2020: '7',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '82,98%',
            ranking2020: '6',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '77,32%',
            ranking2020: '9',
          },

          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '76,54%',
            ranking2020: '10',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '75,82%',
            ranking2020: '8',
          },
        ],
      },
      {
        name: 'Enfermería',
        link: '/rankings-por-carrera/enfermeria/',
        slug: 'enfermeria',
        adid: 'div-gpt-ad-rankingu-4',
        content:
          '<p>Sube la U. de Chile y baja la Católica este año en los primeros lugares y la gran novedad de este ranking es el regreso de las universidades de La Frontera, Mayor y del Bío-Bío al Top 10. Aunque sigue siendo una carrera en la que son más mujeres que hombres —ocho de cada 10—, mantiene una alta demanda. Este 2021 ingresaron más de 7.360 futuros enfermeros, convirtiéndose así en la cuarta carrera que matriculó más estudiantes. Con aranceles que fluctúan entre los $2.300.000 y los $6.500.000 millones, las opciones son variadas. Este año, las cifras indican que la tendencia a la baja en la empleabilidad que tuvo en los últimos años, se revirtió: un 88% estará empleado al segundo año de titularse. Así, el boom por estudiarla se mantiene: 37 mil estudiantes están matriculados. Los sueldos también influyen en su elección: un recién titulado ganará $957 mil, y subirá a $1,5 millones al quinto año de ejercicio. Además, se trata de una carrera con baja deserción y en la que sus estudiantes no tardan más de 6 años terminarla.</p>',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '100%',
            ranking2020: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '99,80%',
            ranking2020: '1',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '96,39%',
            ranking2020: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '94,04%',
            ranking2020: '6',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '90,13%',
            ranking2020: '5',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '89,12%',
            ranking2020: '4',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '85,62%',
            ranking2020: '11',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '83,93%',
            ranking2020: '8',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '82,26%',
            ranking2020: '12',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
            percepcion: '81,16%',
            ranking2020: '13',
          },
        ],
      },
    ],
  },
]

export default rankingData
